'use client';

import { SmartModal } from '@/components/overlay/SmartModal';

import ProfilePredictionDialogContent from './ProfilePredictionDialogContent';

interface I_ProfilePredictionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger?: React.ReactNode;
  handleBarVariant?: 'default' | 'top';
  defaultTab?: 'prime' | 'flash';
  type?: 'winners' | 'missed' | 'ongoing' | 'resolving';
  variant?: 'BTC' | 'ETH' | 'SOL' | 'XRP';
  predictionAddress?: string | null;
  predictionId?: string | null;
  allowConfetti?: boolean;
  selectedParticipation?: {
    predictionEvent: {
      name: string;
      tokenSymbol: string;
      shortName?: string;
      endTime: string;
      resolutionTime?: string;
      realPriceDecimal: string | null;
    };
  } | null;
  onClaimingStateChange?: (isClaiming: boolean) => void;
  onClaimSuccess?: () => void;
}

export default function ProfilePredictionDialog({
  open,
  onOpenChange,
  trigger,
  handleBarVariant = 'top',
  defaultTab = 'prime',
  type = 'winners',
  variant = 'BTC',
  predictionAddress,
  predictionId,
  selectedParticipation,
  onClaimingStateChange,
  onClaimSuccess,
  allowConfetti
}: I_ProfilePredictionDialogProps) {
  const content = (
    <ProfilePredictionDialogContent
      isOpen={open}
      type={type}
      variant={variant}
      closeModal={() => onOpenChange(false)}
      defaultTab={defaultTab}
      allowConfetti={allowConfetti}
      predictionAddress={predictionAddress}
      predictionId={predictionId}
      selectedParticipation={selectedParticipation}
      onClaimingStateChange={onClaimingStateChange}
      onClaimSuccess={onClaimSuccess}
    />
  );

  return (
    <SmartModal
      open={open}
      onOpenChange={onOpenChange}
      trigger={trigger}
      dialogType="dialog"
      variant="glass"
      a11yTitle="Prediction Winners"
      showClose={true}
      handleBarVariant={handleBarVariant}
      mobileContent={content}
      desktopContent={content}
      tabletContent={content}
      fallbackContent={content}
    />
  );
}
